import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons"
import { Button, Checkbox, Tabs } from "antd"
import { t } from "i18next"
import React from "react"

interface PostsComponentProps {
  expandedPosts: boolean
  togglePostsExpand: () => void
  subTab: string
  handleSubTabChange: (key: string) => void
  mostRecentPosts: { name: string }[]
  checkedItems: string[]
  handleCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>, name: string) => void
  handlePostSelectAll: () => void
  addToMenu: () => void
}

const PostsItem: React.FC<PostsComponentProps> = ({
  expandedPosts,
  togglePostsExpand,
  subTab,
  handleSubTabChange,
  mostRecentPosts,
  checkedItems,
  handleCheckboxChange,
  handlePostSelectAll,
  addToMenu,
}) => {
  return (
    <div className="border">
      <div className="flex justify-between p-[10px]" onClick={togglePostsExpand}>
        <p className="text-base font-medium">{t("Post")}</p>
        <p>{expandedPosts ? <CaretUpOutlined /> : <CaretDownOutlined />}</p>
      </div>

      <div
        className={`px-[10px] transition-all duration-300 ${
          expandedPosts ? "max-h-[400px] overflow-hidden" : "max-h-0 overflow-hidden"
        }`}
      >
        <Tabs
          onChange={handleSubTabChange}
          type="card"
          activeKey={subTab}
          className="pt-4"
          items={[
            {
              label: t("Most Recent"),
              key: "tabMos",
            },
          ]}
        />
        {subTab === "tabMos" && (
          <div>
            <div className="flex flex-col space-y-2 max-h-[200px] p-[10px] overflow-y-auto flex-1 border border-1">
              {mostRecentPosts.map((item, index) => (
                <Checkbox
                  key={index}
                  checked={checkedItems.includes(item.name)}
                  onChange={e => handleCheckboxChange(e as any, item.name)}
                >
                  {item.name}
                </Checkbox>
              ))}
            </div>
            <div className="flex justify-between py-[10px] items-center">
              <Checkbox
                onClick={handlePostSelectAll}
                checked={mostRecentPosts.every(post => checkedItems.includes(post.name))}
              >
                {t("Select All")}
              </Checkbox>
              <Button onClick={addToMenu}>{t("Add to menu")}</Button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default PostsItem
